export default __webpack_public_path__ + "static/media/icon-dot-gov.8f8f40ed.svg";